import { render } from "./PropertyListView.vue?vue&type=template&id=b650dfac&scoped=true"
import script from "./PropertyListView.vue?vue&type=script&lang=js"
export * from "./PropertyListView.vue?vue&type=script&lang=js"

import "./PropertyListView.vue?vue&type=style&index=0&id=b650dfac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b650dfac"]])

export default __exports__